var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "z-key-indicator", class: _vm.classObject }, [
    !!this.$slots["icon"]
      ? _c("div", { staticClass: "z-key-indicator__icon" }, [_vm._t("icon")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "z-key-indicator__wrapper" }, [
      _c("div", { staticClass: "z-key-indicator__body" }, [
        _vm.name
          ? _c("span", { staticClass: "z-key-indicator__name" }, [
              _vm.theme === "stock"
                ? _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.buildPercent(_vm.name)) },
                  })
                : _c("span", { domProps: { innerHTML: _vm._s(_vm.name) } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.value || _vm.valueText || _vm.valueTextBefore
          ? _c("div", { staticClass: "z-key-indicator__container" }, [
              _vm.circleColor || _vm.circleTheme
                ? _c("div", {
                    class: [
                      "z-key-indicator__circle",
                      ((_obj = {}),
                      (_obj[
                        "z-key-indicator__circle--theme-" + this.circleTheme
                      ] = this.circleTheme),
                      _obj),
                    ],
                    style: {
                      backgroundColor: _vm.circleColor,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "z-key-indicator__value-wrapper",
                    { "z-key-indicator__value-wrapper--column": _vm.column },
                  ],
                },
                [
                  _vm.valueTextBefore
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "z-key-indicator__value-text z-key-indicator__value-text--before",
                        },
                        [
                          _c("vue-raw", {
                            attrs: { raw: _vm.valueTextBefore },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.value
                    ? _c("span", {
                        staticClass: "z-key-indicator__value",
                        domProps: { innerHTML: _vm._s(_vm.value) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.valueText
                    ? _c(
                        "span",
                        { staticClass: "z-key-indicator__value-text" },
                        [_c("vue-raw", { attrs: { raw: _vm.valueText } })],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.caption
          ? _c(
              "span",
              { staticClass: "z-key-indicator__caption" },
              [_c("vue-raw", { attrs: { raw: _vm.caption } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !!this.$slots["footer"]
        ? _c(
            "div",
            { staticClass: "z-key-indicator__footer" },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }